import { useSyncExternalStore } from 'react';

import {
  type AuthenticationStoreSnapshot,
  getAuthSnapshot,
  subscribeToAuthChanges,
} from './authenticationStore';

/**
 * React hook that exposes a reactive snapshot of the authentication store.
 *
 * Prefer this over calling `AuthenticationStore()` directly inside components:
 * imperative reads happen at render time and don't re-render when cookies /
 * storage change underneath, which leads to subtle "stale auth" bugs (e.g. an
 * auth gate stays truthy after `clearAuthentication()` runs).
 *
 * The snapshot is updated when any mutator on `AuthenticationStore` runs
 * (saveAuthentication, clearAuthentication, setCsrf, …) and on cross-tab
 * `storage` events. Use the existing `AuthenticationStore()` factory for the
 * imperative setters.
 */
export const useAuthenticationStore = (): AuthenticationStoreSnapshot =>
  useSyncExternalStore(
    subscribeToAuthChanges,
    getAuthSnapshot,
    getAuthSnapshot,
  );
